import React, { useState } from 'react';
import { Button, Card, Form, Alert, Badge } from 'react-bootstrap';
import { checkWaitlistStatus } from 'helpers/waitlist';
import { useTranslation } from 'react-i18next';

const STATUS_VARIANTS = {
  pending: 'warning',
  under_review: 'info',
  approved: 'success',
  rejected: 'danger',
  invited: 'primary',
  converted: 'success',
  archived: 'secondary',
};

const WaitlistStatusCheck = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [entry, setEntry] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCheck = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setEntry(null);
    try {
      const data = await checkWaitlistStatus(email, password);
      setEntry(data.entry);
    } catch (err) {
      const msg = err.response?.data?.error || t('WAITLIST.STATUS_CHECK.ERROR_NOT_FOUND');
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Form onSubmit={handleCheck} className="mb-4">
        <Form.Group className="mb-3">
          <Form.Label>{t('WAITLIST.FIELDS.EMAIL_ADDRESS')}</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('WAITLIST.FIELDS.EMAIL_PLACEHOLDER')}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>{t('WAITLIST.FIELDS.PASSWORD')}</Form.Label>
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t('WAITLIST.FIELDS.PASSWORD')}
            required
          />
          <Form.Text className="text-muted">
            {t('WAITLIST.STATUS_CHECK.PASSWORD_HELP')}
          </Form.Text>
        </Form.Group>
        <Button type="submit" disabled={loading || !email.trim() || !password.trim()}>
          {loading ? t('WAITLIST.STATUS_CHECK.CHECKING') : t('WAITLIST.STATUS_CHECK.CHECK_STATUS')}
        </Button>
      </Form>

      {error && <Alert variant="danger">{error}</Alert>}

      {entry && (
        <Card className="bg-light">
          <Card.Body>
            <h6>{t('WAITLIST.STATUS_CHECK.APPLICATION_FOR', { name: `${entry.first_name} ${entry.last_name}` })}</h6>
            <p className="mb-2">
              <strong>{t('WAITLIST.STATUS_CHECK.STATUS')}:</strong>{' '}
              <Badge bg={STATUS_VARIANTS[entry.status] || 'secondary'}>
                {entry.status.replace('_', ' ')}
              </Badge>
            </p>
            <p className="mb-1"><strong>{t('WAITLIST.STATUS_CHECK.EMAIL')}:</strong> {entry.email}</p>
            {entry.company_name && <p className="mb-1"><strong>{t('WAITLIST.STATUS_CHECK.COMPANY')}:</strong> {entry.company_name}</p>}
            <p className="mb-0 text-muted small">{t('WAITLIST.STATUS_CHECK.SUBMITTED')}: {new Date(entry.created_at).toLocaleDateString()}</p>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default WaitlistStatusCheck;
